import { useContext, useEffect } from "react";
import { useRouter } from "next/router";
import { useEntities } from "@/contexts/entities/EntitiesContext";
import { NavigatorContext } from "@/contexts/navigator/NavigatorContext";
import { getSelectionQueryParamFromRouter } from "@/lib/utils";

export function useNavigatorSelection() {
  const router = useRouter();
  const {
    activeCompetencyId,
    activeLearnerOutcomeId,
    updateLearnerOutcome,
    updateCompetency,
    updateSubCompetency,
    updatePerformanceLevel,
    reset,
  } = useContext(NavigatorContext);
  const { getEntityHierarchyFromId } = useEntities();

  const selectionId = getSelectionQueryParamFromRouter(router);

  useEffect(() => {
    if (!selectionId || Array.isArray(selectionId)) {
      reset();
      return () => reset();
    }

    const hierarchy = getEntityHierarchyFromId(selectionId);
    if (hierarchy.learnerOutcome) {
      updateLearnerOutcome(hierarchy.learnerOutcome.id);
    }
    if (hierarchy.competency) {
      updateCompetency(hierarchy.competency.id);
    }
    if (hierarchy.subCompetency) {
      updateSubCompetency(hierarchy.subCompetency.id);
    }
    if (hierarchy.performanceLevel) {
      updatePerformanceLevel(hierarchy.performanceLevel.id);
    }

    return () => reset();
  }, [
    selectionId,
    updateCompetency,
    updateLearnerOutcome,
    updateSubCompetency,
    updatePerformanceLevel,
    reset,
    getEntityHierarchyFromId,
  ]);

  const changeSelection = async (selectionId: string) => {
    await router.push(
      {
        pathname: router.pathname,
        query: { ...router.query, selection: selectionId },
      },
      undefined,
      { shallow: true },
    );
  };

  return { activeCompetencyId, activeLearnerOutcomeId, changeSelection };
}
